module.exports = __webpack_public_path__ + "img/mario-renn.55c29848.jpg";